import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Link, LazyImage } from '@grandvisionhq/common';
import { ProductBlockImagePlaceholder } from './components/ProductBlockImagePlaceholder.js';
import { createResponsiveImage, defaultSettings } from './utils/responsive-image.js';

const ProductBlockImages = ({ frontAlt , frontUrl , angleUrl , href , onClick ,  })=>{
    const isPhone = MediaQuery.useIsPhone();
    const responsiveFrontImage = createResponsiveImage(frontUrl, frontAlt);
    const responsiveAngleImage = createResponsiveImage(angleUrl);
    return /*#__PURE__*/ React.createElement(Link, {
        href: href,
        tabIndex: -1,
        className: "product-block-images",
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            paddingBottom: `${defaultSettings.height / defaultSettings.width * 100}%`
        },
        className: classnames('product-block-images__container', {
            // Only enable hover behaviour if we have have an angle image as well and are not on a phone
            'product-block-images__container--hover': !!angleUrl && !isPhone
        })
    }, responsiveFrontImage && /*#__PURE__*/ React.createElement("div", {
        className: "product-block-images__image product-block-images__image--front"
    }, /*#__PURE__*/ React.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, responsiveFrontImage, {
        rootMargin: "150px 0px",
        isContained: true,
        placeholder: /*#__PURE__*/ React.createElement(ProductBlockImagePlaceholder, {
            src: responsiveFrontImage.src,
            alt: responsiveFrontImage.alt
        })
    }))), angleUrl && !isPhone && /*#__PURE__*/ React.createElement("div", {
        className: "product-block-images__image product-block-images__image--angle"
    }, /*#__PURE__*/ React.createElement(LazyImage, swcHelpers.extends({}, defaultSettings, responsiveAngleImage, {
        rootMargin: "150px 0px",
        isContained: true,
        placeholder: /*#__PURE__*/ React.createElement(ProductBlockImagePlaceholder, {
            src: responsiveAngleImage.src,
            alt: responsiveAngleImage.alt
        })
    })))));
};

export { ProductBlockImages };
//# sourceMappingURL=ProductBlockImages.js.map
